import { BeaconClient, buildGeo } from "@beacon/client-core";

/** Privacy-policy version stamped on consent records (privacy spec date). */
export const POLICY_VERSION = "2026-06-10";

export type ConsentPurpose = "alerts" | "helperAvailability" | "preciseLocationRelease" | "publicMetrics";
export type ConsentAction = "grant" | "withdraw";
export type ShredScope = "event" | "identity" | "thread";

export interface ConsentInput { purpose: ConsentPurpose; action: ConsentAction; cell: string }
export interface ShredInput { scope: ShredScope; target: string; cell: string }

/** Record a signed consent grant/withdraw (privacy §7) — lexicon-validated at buildEnvelope. */
export async function publishConsent(client: BeaconClient, input: ConsentInput) {
  return client.publish({
    $type: "app.aid.privacy.consent",
    payload: { purpose: input.purpose, action: input.action, policyVersion: POLICY_VERSION },
    geo: buildGeo(input.cell),
  });
}

/** Sign an erasure request (privacy §6 / §4.1). The A2 key-registry folds it and destroys keys. */
export async function publishShred(client: BeaconClient, input: ShredInput) {
  return client.publish({
    $type: "app.aid.privacy.shred",
    payload: { scope: input.scope, target: input.target },
    geo: buildGeo(input.cell),
  });
}
